export const getters = {
  getLayers: state => state.layers
}
